<template>
  <v-text-field
    class="currency-input"
    ref="textField"
    @input="emitNumberValue($event, 'input')"
    @change="emitNumberValue($event, 'change')"
    v-currency="currencyOptions"
    :currency="currency"
    :suffix="currency"
    :prefix="prefix"
    :error-messages="customErrorMessages"
    v-bind="$attrs"
  />
</template>

<script>
import {CurrencyDirective, parseCurrency, setValue as setCurrencyInputValue} from 'vue-currency-input';
import {locale} from '../plugins/i18n'
import {LocaleUtils} from '@/utils/locale-utils.js';

export default {
  mixins: [
    LocaleUtils
  ],
  props: ['value', 'currency', 'allowNegative', 'allowOnlyNegative', 'rules', 'errorMessages', 'precision', 'withPositiveIndicator'],
  directives: {
    currency: CurrencyDirective
  },
  data () {
    return {
      errorMessageByCustomValidation: null
    }
  },
  mounted () {
    this.setValueFromInternal();
  },
  computed: {
    currencyOptions () {
      return {
        currency: null, // Displayed via v-text-field prefix
        locale: locale,
        precision: (typeof this.precision === 'number') ? this.precision : 2,
        allowNegative: this.allowNegative || this.allowOnlyNegative || true
      };
    },

    customErrorMessages () {
      if (this.errorMessageByCustomValidation) {
        return this.errorMessageByCustomValidation;
      } else if (this.errorMessages) {
        return this.errorMessages;
      }
      return [];
    },

    prefix () {
      if (this.withPositiveIndicator && this.value > 0) {
        return '+';
      }
      return null;
    },

    internalRules () {
      let internalRules = [...(this.rules || [])];
      if (this.allowOnlyNegative) {
        internalRules.push(v => v === null || v < 0 || this.trans('validationErrors.negative'));
      }
      return internalRules;
    }
  },
  methods: {
    emitNumberValue (textValue, eventType) {
      let parsedNumber = parseCurrency(textValue, this.currencyOptions);
      this.errorMessageByCustomValidation = null;
      if (this.internalRules) {
        for (const rule of this.internalRules) {
          let ruleResult = rule(parsedNumber);
          if (typeof ruleResult === 'string') {
            this.errorMessageByCustomValidation = ruleResult;
            break;
          }
        }
      }
      this.$emit(eventType, parsedNumber);
    },
    setValueFromInternal () {
      try {
        setCurrencyInputValue(this.$refs['textField'].$refs['input'], this.value);
      } catch (e) {
        console.warn('[currency-input] Cannot set value', e);
      }
    }
  },

  watch: {
    value () {
      this.setValueFromInternal();
    }
  }
}
</script>


<style>
.currency-input .v-text-field__suffix {
  font-size: 0.8em;
  opacity: 0.9;
  margin-top: 2px;
  margin-right: 1px;
}
.currency-input .v-text-field__prefix {
  font-size: 0.8em;
  padding-right: 1px;
}
</style>
